module.exports = __webpack_public_path__ + "img/logo.27dfd16a.svg";